import { TextV2 } from '@insights-ltd/design-library/components';
import { styled } from '@mui/material';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type NotificationProps = {
  message: string;
};

const StyledDiv = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(spacingSizeMap.M),
  padding: `${theme.spacing(spacingSizeMap.S)} ${theme.spacing(
    spacingSizeMap.M,
  )}`,
  background: theme.palette.primary.light,
  borderRadius: '4px',
  maxWidth: '720px',
}));

const Notification = ({ message }: NotificationProps) => {
  return (
    <StyledDiv>
      <TextV2 component="span" variant="bodyBold">
        {message}
      </TextV2>
    </StyledDiv>
  );
};

export default Notification;
